import { render, staticRenderFns } from "./PlayerStatComponent.vue?vue&type=template&id=ec86ae3a&scoped=true&"
import script from "./PlayerStatComponent.vue?vue&type=script&lang=js&"
export * from "./PlayerStatComponent.vue?vue&type=script&lang=js&"
import style0 from "./PlayerStatComponent.vue?vue&type=style&index=0&id=ec86ae3a&prod&lang=css&"
import style1 from "./PlayerStatComponent.vue?vue&type=style&index=1&id=ec86ae3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec86ae3a",
  null
  
)

export default component.exports